/**
 * Handles first-party persistence of attribution data.
 *
 * Cookies are primary storage.
 * localStorage is used as a fallback.
*/

var AttributionStorage = (function () {
  'use strict';

  var ATTR_DEBUG = false;
  var COOKIE_NAME = '_attr_payload';
  var COOKIE_DAYS = 30;

  function log() {
    if (ATTR_DEBUG) console.log.apply(console, arguments);
  }

  /**
   * Writes a first-party cookie scoped to the root domain.
   * SameSite=Lax allows normal navigation while preventing most CSRF abuse.
   */
  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 86400000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/; SameSite=Lax';
    log('[Attribution][Storage] Cookie set:', name);
  }

   /**
   * Reads a cookie by name.
   * Returns null if not found.
   */
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(nameEQ) === 0) {
        log('[Attribution][Storage] Cookie found:', name);
        return decodeURIComponent(c.substring(nameEQ.length));
      }
    }
    log('[Attribution][Storage] Cookie not found:', name);
    return null;
  }

  /**
   * Persists the full attribution payload.
   * Cookie is written first, localStorage is best-effort.
   */
  function storePayload(payload) {
    log('[Attribution][Storage] Storing payload:', payload);

    var serialized = JSON.stringify(payload);
    setCookie(COOKIE_NAME, serialized, COOKIE_DAYS);

    try {
      localStorage.setItem(COOKIE_NAME, serialized);
      log('[Attribution][Storage] Payload stored in localStorage');
    } catch (e) {
      log('[Attribution][Storage] localStorage unavailable');
    }
  }

  /**
   * Stores a session record without attribution details.
   * Used when consent is denied or no attribution exists.
   */
  function storeSessionOnly(payload) {
    log('[Attribution][Storage] Storing session-only payload (no attribution)');

    var sessionPayload = Object.assign({}, payload, { attribution: null });
    storePayload(sessionPayload);
  }

  /**
   * Reads the persisted payload.
   * Cookie is preferred; localStorage is fallback only.
   */
  function read() {
    log('[Attribution][Storage] Reading persisted payload');

    var value = getCookie(COOKIE_NAME);
    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        log('[Attribution][Storage] Failed to parse cookie JSON');
      }
    }

    try {
      var ls = localStorage.getItem(COOKIE_NAME);
      if (ls) return JSON.parse(ls);
    } catch (e) {}

    log('[Attribution][Storage] No payload found');
    return null;
  }

  return {
    storePayload: storePayload,
    storeSessionOnly: storeSessionOnly,
    read: read
  };

})();

